import { Injectable, inject } from '@angular/core';
import { CookieService } from 'ngx-cookie';
import jwt_decode from 'jwt-decode';
import { environment } from 'environments/environment';
import { Departaments } from '../models/departaments.model';
import { JwtUserClaims } from '../models/security-contracts';

@Injectable()
export class OABCookieService {
    private cookieService = inject(CookieService);


    getOabAccessToken(): JwtUserClaims {
        // O access token e criptografado (JWE) e nao e decodificavel no front; as claims do
        // usuario sao lidas do id_token (assinado/legivel).
        return jwt_decode<JwtUserClaims>(this.cookieService.get(environment.oab_id_token));
    }

    getIdenConta(): number {
        return parseInt(this.getOabAccessToken().sub, 10);
    }

    getOrganizacaoPadrao(): number {
        return parseInt(this.cookieService.get(environment.oab_organizacao_padrao), 10);
    }

    getSetorPadrao() : number {
        return parseInt(this.cookieService.get(environment.oab_setor_padrao), 10);
    }

    getUsersPermissions(): Departaments[] {
        // Migrado de cookie .oab.org.br para localStorage: o JSON de orgs/setores pode ser grande
        // (usuário com muitas organizações) e o cookie de domínio ia em TODA requisição a
        // *.oab.org.br, estourando o buffer de header do nginx dos apps legados
        // (400 "Request Header Or Cookie Too Large"). Fallback ao cookie antigo para sessões
        // criadas antes da migração.
        const stored = localStorage.getItem(environment.oab_orgs_user_permission)
            ?? this.cookieService.get(environment.oab_orgs_user_permission);
        return JSON.parse(stored);
    }

    setOrgsUserPermission(orgs: Departaments[]): void {
        localStorage.setItem(environment.oab_orgs_user_permission, JSON.stringify(orgs));

        // Remove o cookie antigo (host-only e de domínio compartilhado), se existir, para
        // limpar sessões que ainda o carregam no header — mesmo padrão da migração do
        // refresh token (auth.service.storeTokens).
        const expiredAt = 'Thu, 01 Jan 1970 00:00:00 GMT';
        document.cookie = `${environment.oab_orgs_user_permission}=; expires=${expiredAt}; path=/`;
        document.cookie = `${environment.oab_orgs_user_permission}=; expires=${expiredAt}; path=/; domain=.oab.org.br`;
    }
}